import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriUserDetailsComponent } from '../../components/gonvarri-user-details/gonvarri-user-details.component';
import {I18nModule, provideConfig, provideDefaultConfig, UrlModule} from "@spartacus/core";
import {RouterModule} from "@angular/router";
import {KeyboardFocusModule} from "@spartacus/storefront";
import {
  CardModule,
  DisableInfoModule,
  SharedOrganizationModule,
  ToggleStatusModule
} from "@spartacus/organization/administration/components";
import {gonvarriUserCmsConfig} from "../../core/configs/user.config";

@NgModule({
  declarations: [
    GonvarriUserDetailsComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    RouterModule,
    UrlModule,
    I18nModule,
    ToggleStatusModule,
    SharedOrganizationModule,
    DisableInfoModule,
    KeyboardFocusModule,
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        UserDetailsComponent: {
          component: GonvarriUserDetailsComponent
        }
      }
    }),
    provideConfig(gonvarriUserCmsConfig),
  ]
})
export class GonvarriUserDetailsModule { }
